import styled from 'styled-components';
import menuHover from './menu-hover.svg';
import menu from './menu.svg';

const Menu = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  background: url(${({ icon }) => icon || menu}) no-repeat center;
  opacity: ${({ toggledOn }) => (toggledOn ? 1 : 0.5)};
  cursor: pointer;

  &:hover {
    background-image: url(${({ iconHover }) => iconHover || menuHover});
    opacity: 1;
  }
`;

export default Menu;
